import notificationsLocale from './en.json'

const en = {
  notifications: notificationsLocale,
}

export default en
